import jwtDecode from "jwt-decode";

const STORAGE_PREFIX = "labels:";

const getEnterpriseId = () => {
  try {
    return jwtDecode(window.localStorage.getItem("accessToken")).enterpriseId;
  } catch {
    return null;
  }
};

const getStorageKey = (language, namespace) => {
  const enterpriseId = getEnterpriseId();

  return enterpriseId ? `${STORAGE_PREFIX}${enterpriseId}:${language}:${namespace}` : null;
};

const getCachedLabels = key => {
  try {
    return JSON.parse(window.sessionStorage.getItem(key));
  } catch {
    return null;
  }
};

export const labelsCacheBackend = {
  type: "backend",
  init: () => {},
  read: (language, namespace, callback) => {
    const key = getStorageKey(language, namespace);

    callback(null, key ? getCachedLabels(key) : null);
  },
  save: (language, namespace, labels) => {
    const key = getStorageKey(language, namespace);

    if (!key) return;

    try {
      window.sessionStorage.setItem(key, JSON.stringify(labels));
    } catch {}
  },
};

export const clearCachedLabels = () => {
  try {
    Object.keys(window.sessionStorage)
      .filter(key => key.startsWith(STORAGE_PREFIX))
      .forEach(key => window.sessionStorage.removeItem(key));
  } catch {}
};
